var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{ref:"text",staticClass:"wander-text"},_vm._l(('wander'),function(letter,i){return _c('span',{key:i,class:_vm.letterClasses(letter),attrs:{"name":"letter"}},[_vm._v("\n    "+_vm._s(letter)+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }